import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackbaseCoreModule } from '@backbase/foundation-ang/core';
import { AccountSelectorWidgetExtendedComponent } from './account-selector-widget-extended.component';
import { ProductSummaryAccountSelectorWidgetModule } from '@backbase/product-summary-account-selector-widget-ang';
import { AmountModule } from '@backbase/ui-ang';
import { BnAccountSelectorItemComponent } from './components/account-selector-item/account-selector-item.component';
import { BnAlertComponent } from './components/bn-alert/bn-alert.component';
import { BnAccountSelectorWrapperComponent } from './components/account-selector-wrapper/account-selector-wrapper.component';
import { FormsModule } from '@angular/forms';
import { UtilsService } from './components/account-selector-item/utils/util-service';
import { BnCCFormatPipe } from '../lib/pipes/bn-credit-card-format/bn-credit-card-format';

@NgModule({
  declarations: [
    AccountSelectorWidgetExtendedComponent,
    BnAccountSelectorWrapperComponent,
    BnAlertComponent,
    BnAccountSelectorItemComponent,
    BnCCFormatPipe,
  ],
  imports: [
    CommonModule,
    AmountModule,
    FormsModule,
    ProductSummaryAccountSelectorWidgetModule,
    BackbaseCoreModule.withConfig({
      classMap: { AccountSelectorWidgetExtendedComponent },
    }),
  ],
  providers: [UtilsService],
  exports: [AccountSelectorWidgetExtendedComponent,
    BnAccountSelectorItemComponent,BnAccountSelectorWrapperComponent,BnAlertComponent]
})
export class AccountSelectorWidgetExtendedModule {}
